import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import isString from "lodash/isString";

const operationColumnApi = AiseaApiFactory.get("operationColumn");

class OperationColumnService {
  /**
   * APIでカスタムカラム設定一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {OperationColumn[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  async getOperationColumns() {
    return await operationColumnApi.index();
  }

  validOperationColumns(
    operationColumns // : OperationColumn[]
  ) {
    const ocs = operationColumns;
    if (!Array.isArray(ocs)) return [];
    return ocs.filter((
      oc // :OperationColumn
    ) => this.isValidOperationColumn(oc));
  }

  /**
   * Checks if the given object is a valid OperationColumn.
   *
   * @param {any} operationColumn - The object to validate.
   * @returns {boolean} - Returns true if the object is a valid OperationColumn, false otherwise.
   */
  isValidOperationColumn(
    operationColumn // : OperationColumn
  ) {
    const oc = operationColumn;
    if (!isObject(oc)) return false;
    return (
      Array.isArray(oc.ao_enterprise_column_form_version_items) &&
      isString(oc.ao_enterprise_id) &&
      isString(oc.id) &&
      isNumber(oc.min_width) &&
      isString(oc.name)
    );
  }

  /**
   * Checks if the given object is a valid ColumnItem.
   *
   * @param {ColumnItem} columnItem - The object to validate.
   * @returns {boolean} - Returns true if the object is a valid ColumnItem, false otherwise.
   */
  isValidColumnItem(
    columnItem // :ColumnItem
  ) {
    const ci = columnItem;
    if (!isObject(ci)) return false;
    return (
      isString(ci.ao_enterprise_column_id) &&
      isString(ci.form_version_item_id) &&
      isString(ci.id)
    );
  }
}

export default new OperationColumnService();
